// Utilitaires pour détecter le navigateur et l'OS
export const isSafari = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
};

export const isMacOS = (): boolean => {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};

export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const isAppleDevice = (): boolean => {
  return isMacOS() || isIOS();
};

export const supportsAppleSignIn = (): boolean => {
  // Apple Sign In fonctionne mieux sur Safari et les appareils Apple
  return true; // Firebase gère la compatibilité
};

export const getDeviceInfo = () => {
  return {
    isSafari: isSafari(),
    isMacOS: isMacOS(),
    isIOS: isIOS(),
    isAppleDevice: isAppleDevice(),
    supportsAppleSignIn: supportsAppleSignIn(),
  };
};
